module.exports = __webpack_public_path__ + "static/media/background-image.979cd865.png";